import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './ExchangeRetirementIncomeWithholdings.scss';

import { moduleActions } from '../../../redux/modules';
import { getAcceptedRI2020WithholdingDisclosure } from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { RI2020_WITHHOLDING_DISCLOSURE_MODAL } from '../../../redux/modules/modals/modals.module';
import Checkbox from '../../Shared/Checkbox/Checkbox';

const ExchangeRetirementIncomeWithholdings = ({
  acceptedRI2020WithholdingDisclosure,
  actions: { acceptRI2020WithholdingDisclosure, openModal },
  modalsSeen,
}) => (
  <div className="exchange-retirement-income-withholdings-container">
    <div className="exchange-retirement-income-withholdings-small-paragraph">
      Unless you elect no federal income tax withholding or request withholding
      at a higher rate, the withholding rate of 10% and any mandatory state
      withholding will be applied to your monthly Retirement Income 2020 Cash
      Dividend distributions.
    </div>
    <div className="exchange-retirement-income-withholdings-small-paragraph">
      If you would like to request an alternate withholding rate, you can do so
      on the following business day.
    </div>
    <div className="exchange-retirement-income-withholdings-headline">
      You must read the Income Tax Withholding Disclosure to complete this
      transaction.
    </div>
    <a
      onClick={() => openModal(RI2020_WITHHOLDING_DISCLOSURE_MODAL)}
      className="exchange-retirement-income-withholdings-link"
    >
      Income Tax Withholding Disclosure
    </a>
    <div className="exchange-retirement-income-withholdings-acceptance">
      <Checkbox
        ariaLabel="I have read the Income Tax Withholding Disclosure"
        checked={acceptedRI2020WithholdingDisclosure}
        id="ri2020-withholding-disclosure"
        inline
        onClick={(checked) =>
          modalsSeen[RI2020_WITHHOLDING_DISCLOSURE_MODAL]
            ? acceptRI2020WithholdingDisclosure(checked)
            : openModal(RI2020_WITHHOLDING_DISCLOSURE_MODAL)
        }
      />
      <label
        htmlFor="ri2020-withholding-disclosure"
        className="exchange-retirement-income-withholdings-acceptance-label"
      >
        I have read the Income Tax Withholding Disclosure
      </label>
    </div>
  </div>
);

const mapStateToProps = (state) => {
  const { modalsSeen } = state.modals;
  return {
    acceptedRI2020WithholdingDisclosure:
      getAcceptedRI2020WithholdingDisclosure(state),
    modalsSeen,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExchangeRetirementIncomeWithholdings
);
